<template>
    <v-container fluid class="mt-0">

        <ApolloQuery
                client-id="clientPrivate"
                :query="require('../graphql/queries/customerPayment.gql')">
            <template v-slot="{ result: { error, data },isLoading }">

                <v-layout v-if="isLoading" class="loading" row wrap align-center
                          justify-center fill-height>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="1"
                                height="15"
                                indeterminate
                                color="blueprimary"
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>


                <template v-if="data">
                    <template v-if="data.customer.paymentEnabled">
                        <v-layout row wrap align-start align-content-start
                                  class="payment">
                            <v-flex xs12 class="current-credit">
                                <ApolloQuery
                                        ref="balanceQuery"
                                        :query="require('../graphql/queries/currentUserFull.gql')"
                                        client-id="clientPrivate">
                                    <template
                                            v-slot="{ result: { error, data },isLoading }">
                                        <v-layout wrap row>
                                            <v-flex xs6 class="text-xs-left">
                                                {{$vuetify.t("$vuetify.Credit.availableCredit")}}
                                            </v-flex>
                                            <v-flex xs6
                                                    class="text-xs-right font-weight-bold credit">
                                                <template v-if="data">
                                                    {{$vuetify.t("$vuetify.Credit.currency")}}
                                                    {{ data.user.balance}}
                                                </template>
                                                <template v-if="isLoading">
                                                    <v-progress-circular
                                                            width="1"
                                                            size="19"
                                                            indeterminate
                                                            color="bluetext">
                                                    </v-progress-circular>
                                                </template>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </ApolloQuery>
                            </v-flex>
                            <v-flex xs12 class="recharge-section">
                                <v-layout wrap row class="recharge-box-title">
                                    {{$vuetify.t("$vuetify.Credit.rechargeCredit")|uppercase}}
                                </v-layout>
                                <v-layout row class="recharge-button-box">
                                    <ApolloQuery
                                            class="full-width"
                                            :query="require('../graphql/queries/currentCustomer.gql')"
                                            client-id="clientPrivate"
                                            :update="assignDefaultPaymentSize">
                                        <template
                                                v-slot="{ result: { error, data },isLoading }">

                                            <v-layout v-if="data" row>
                                                <v-flex xs4>
                                                    <v-btn class="first button-charge-size"
                                                           :class="{active: chargeSize == data.customer.paymentSize1 }"
                                                           @click="chargeSize = data.customer.paymentSize1">
                                                        {{$vuetify.t("$vuetify.Credit.currency")}}
                                                        {{data.customer.paymentSize1}}
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-btn class="button-charge-size"
                                                           :class="{active: chargeSize == data.customer.paymentSize2}"
                                                           @click="chargeSize = data.customer.paymentSize2">
                                                        {{$vuetify.t("$vuetify.Credit.currency")}}
                                                        {{data.customer.paymentSize2}}
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-btn class="button-charge-size"
                                                           :class="{active: chargeSize == data.customer.paymentSize3}"
                                                           @click="chargeSize = data.customer.paymentSize3">
                                                        {{$vuetify.t("$vuetify.Credit.currency")}}
                                                        {{data.customer.paymentSize3}}
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-flex v-if="isLoading" xs12>
                                                <v-progress-circular
                                                        width="2"
                                                        size="40"
                                                        indeterminate
                                                        color="bluetext">
                                                </v-progress-circular>
                                            </v-flex>
                                        </template>
                                    </ApolloQuery>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout class="payments-method">
                            <v-flex v-if="waitingPaymentResponse" xs12
                                    class="waitingPayment">
                                <v-layout fill-height justify-center align-center>
                                    <v-progress-circular
                                            :size="70"
                                            :width="2"
                                            height="15"
                                            indeterminate
                                            color="bluetext">
                                    </v-progress-circular>
                                </v-layout>
                            </v-flex>
                            <braintree v-if="data.customer.braintreeEnabled"
                                       :paymentAmount="chargeSize"
                                       :locale="`${$options.filters.lowercase($vuetify.lang.current)}_${$vuetify.lang.current}`"
                                       :token="data.customer.braintreeToken"
                                       @startSendNonce="waitingPaymentResponse=true"
                                       @success="onPaymentSuccess()"
                                       :paypal="true"></braintree>
                            <stripe v-if="data.customer.stripeEnabled"
                                     :paymentAmount="chargeSize"
                                     :locale="`${$options.filters.lowercase($vuetify.lang.current)}`"
                                     :stripeAccount="data.customer.stripeAccount"
                                     @success="onPaymentSuccess()">
                            </stripe>
                        </v-layout>
                        <v-layout v-if="false" class="payments-archive">
                            <v-flex xs10 class="text-xs-left">
                                <router-link :to="{ name: 'payments-archive'}"
                                             class="no-link">
                                    {{$vuetify.t("$vuetify.Credit.paymentsArchive")}}
                                </router-link>
                            </v-flex>
                            <v-flex xs2 class="text-xs-right">
                                <v-btn icon :to="{name: 'payments-archive'}">
                                    <v-icon class="ma-0" color="bluetext"
                                            width="27"
                                            height="27">mdi-chevron-right-circle
                                    </v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </template>
                    <template v-else>
                        <v-card-title class="d-block">
                            <div class="error-title">
                                {{$vuetify.t("$vuetify.Credit.noPaymentMethods")}}
                              {{data.customer.paymentEnabled}}
                              test
                            </div>

                            <v-icon size="90" class="d-block" color="error">
                                mdi-close-circle-outline
                            </v-icon>
                            {{$vuetify.t("$vuetify.Credit.noPaymentMethodsMessage")}}
                        </v-card-title>
                    </template>
                </template>

            </template>

        </ApolloQuery>
    </v-container>
</template>

<script>

    import Braintree from "../components/braintree"
    import Stripe from "../components/stripe.vue"

    export default {
        name: 'Credit',
        data() {
            return {
                token: null,
                chargeSize: 5,
                waitingPaymentResponse: false

            }
        },
        methods: {
            onPaymentSuccess() {
                this.$refs.balanceQuery.$apollo.queries.query.refetch()
                this.waitingPaymentResponse = false
            },
            assignDefaultPaymentSize(data) {
                this.chargeSize = data.customer.paymentSize2
                return data
            }
        },
        components: {
          Braintree,
          Stripe
        },

    }
</script>

<style scoped lang="scss">

    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .payment {
        color: var(--v-bluetext-base);

        .recharge-section {
            margin-top: 25px;

            .recharge-button-box {
                margin-top: 17px;

                .button-charge-size {
                    margin: 0px 0px 5px 0px;
                    width: calc(100% - 5px);
                    border: solid;
                    border-color: var(--v-bluetext-base);
                    border-width: 2px;
                    font-size: 20px;
                    color: var(--v-bluetext-base);
                    height: 42px;

                    &.first {
                        margin-left: 0px
                    }

                    &.active {
                        background-color: var(--v-bluetext-base);
                        color: var(--v-primary-base)
                    }
                }
            }
        }

        .current-credit {
            line-height: 20px;

            .credit {
                font-size: 20px;
            }
        }


    }

    .payments-method {
        margin-top: 30px;
        border: 1px solid #707070;
        border-left: none;
        border-right: none;
        padding: 16px 0px;
        position: relative;


        .waitingPayment {
            background-color: var(--v-primary-base);
            height: 100%;
            width: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 5;
            opacity: 0.9;
        }
    }

    .payments-archive {
        color: var(--v-bluetext-base);
        margin-top: 20px;
        line-height: 20px;

        .v-btn {
            margin: 0px;
            height: auto;
            width: auto;
        }


        .no-link {
            color: inherit;
            text-decoration: none;
        }

    }

    .full-width {
        width: 100%;
    }

</style>
